"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreTooltip = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _Tooltip = require("../../tooltip/Tooltip");
var _react = _interopRequireWildcard(require("react"));
var _moreTooltipModule = _interopRequireDefault(require("./more-tooltip.module.scss"));
var _classnames = _interopRequireDefault(require("classnames"));
var _caretRight = require("../../../assets/icons/caret-right.svg");
var MAX_TOOLTIP_LENGHT_FOR_SINGLE_LINE = 50;
var MoreTooltip = function MoreTooltip(_ref) {
  var items = _ref.items,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'bottom' : _ref$position;
  var textLength = items.reduce(function (length, item) {
    return length + item.length;
  }, 0);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    position: position,
    variant: "light",
    className: (0, _classnames.default)(_moreTooltipModule.default['more-tooltip__tooltip'], (0, _defineProperty2.default)({}, _moreTooltipModule.default['more-tooltip__tooltip--long'], textLength > MAX_TOOLTIP_LENGHT_FOR_SINGLE_LINE)),
    containerClassName: _moreTooltipModule.default['more-tooltip'],
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: _moreTooltipModule.default['more-tooltip__content'],
      "data-testid": "more-tooltip"
    }, items.map(function (item, i) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: "".concat(item, "-").concat(i)
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(_moreTooltipModule.default['more-tooltip__element'], (0, _defineProperty2.default)({}, _moreTooltipModule.default['more-tooltip__element--last'], i === items.length - 1))
      }, item), i !== items.length - 1 && /*#__PURE__*/_react.default.createElement(_caretRight.ReactComponent, {
        className: _moreTooltipModule.default['more-tooltip__arrow']
      }));
    }))
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: _moreTooltipModule.default['more-tooltip__icon'],
    "data-testid": "more-icon"
  }));
};
exports.MoreTooltip = MoreTooltip;